import { render, staticRenderFns } from "./footer-for-protected-empty.vue?vue&type=template&id=7b996dae&scoped=true"
import script from "./footer-for-protected-empty.vue?vue&type=script&lang=js"
export * from "./footer-for-protected-empty.vue?vue&type=script&lang=js"
import style0 from "./footer-for-protected-empty.vue?vue&type=style&index=0&id=7b996dae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b996dae",
  null
  
)

export default component.exports